import { Component, effect, inject, OnInit, signal } from '@angular/core';

import { Router, RouterModule } from '@angular/router';

import * as fromSharedUi from '@sandbox-platform/shared-ui';
import { AuthStore } from '../../store/auth.store';
import { NavigationGridComponent } from './components';
import { PortalHeaderComponent } from '../../components';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    PortalHeaderComponent,
    NavigationGridComponent,
    fromSharedUi.BouncingLoaderComponent
],
  selector: 'app-switchboard',
  templateUrl: './switchboard.component.html',
})
export class SwitchboardComponent implements OnInit {
  public authStore = inject(AuthStore);
  private router = inject(Router);
  public isLoading = signal(true);
  private readonly permissionMonitor = effect(() => {
    const user = this.authStore.user();

    if (!user) {
      // Session was invalidated (e.g. background refresh failed after a
      // password change) - bounce to login instead of spinning forever.
      this.isLoading.set(false);
      this.router.navigate(['/login']);
      return;
    }

    this.isLoading.set(false);
  });

  async ngOnInit(): Promise<void> {
    // Load user data from storage if available
    this.authStore.loadFromStorage();
    this.authStore.loadCompanyContext();

    if (this.authStore.requiresPasswordReset()) {
      this.router.navigate(['/force-password-reset']);
      return;
    }
  }

  // Get first name for welcome message
  getFirstName(): string {
    const user = this.authStore.user();
    return user?.first_name || 'User';
  }
}
